import styled from '@emotion/styled';

interface SpacerAreaProps {
  height: string;
}

export const SpacerArea = styled.div<SpacerAreaProps>(
  {
    borderRadius: '8px',
    minHeight: '10px',
    width: '100%',
  },
  props => ({
    height: props.height,
  })
);
